new Swiper('.product-carousel', {
    direction: 'horizontal',
    slidesPerView: 2,
    spaceBetween: 4,
    slidesPerGroup: 2,
    loop: false,
    preventInteractionOnTransition: false,
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    breakpoints: {
        640: {
            slidesPerView: 4,
            preventInteractionOnTransition: false,
            slidesPerGroup: 1,
        }
    }
}); 